export const LogoApple = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-labelledby="appleLogoTitle appleLogoDesc"
    >
      <title id="appleLogoTitle">Apple Logo</title>
      <desc id="appleLogoDesc">Apple Logo</desc>
      <path d="M16.8654 6.41504C14.9754 6.41504 14.1766 7.31691 12.8604 7.31691C11.5108 7.31691 10.4815 6.4216 8.84366 6.4216C7.24053 6.4216 5.531 7.40035 4.44538 9.0677C2.921 11.4189 3.17975 15.8472 5.64866 19.6197C6.53178 20.9702 7.71116 22.4847 9.25803 22.5011H9.28616C10.6305 22.5011 11.0299 21.6208 12.8801 21.6105H12.9082C14.7307 21.6105 15.0963 22.496 16.4351 22.496H16.4632C18.0101 22.4796 19.2527 20.8014 20.1358 19.4561C20.7715 18.4886 21.0077 18.003 21.4952 16.9085C17.9238 15.5529 17.3501 10.4899 20.8821 8.54879C19.804 7.19879 18.289 6.41691 16.8607 6.41691L16.8654 6.41504Z" />
      <path d="M16.4491 1.5C15.3241 1.57641 14.0116 2.29266 13.2428 3.22781C12.5453 4.07531 11.9716 5.3325 12.1966 6.55172H12.2866C13.4847 6.55172 14.711 5.83031 15.4272 4.90594C16.1172 4.02609 16.6403 2.77922 16.4491 1.5Z" />
    </svg>
  );
};
